const state = {
  nav: [],
  selectedTab: "",
  getDataLoading: false,
  saveDataLoading: false,
  updateDataLoading: false,
  getDataSuccess: false,
  content: {},
  logic: {},
  patientRef: null,
  patientData: null,
  canManagePatient: false, // for physician login (datepicker state),
  sequenceNumber: null,
  disabledForm: false,
};

export default state;
